package team.platforma.multiplatform_material_extension.tooltips.model

enum class PopupPosition {
    TOP, BOTTOM
}